import React, { useEffect, useState } from "react";
import "./ConcentrationReport.scss";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const ConcentrationReport = ({startDate, endDate, duration, isCustomFilter}) => {
  const [reportData, setReportData] = useState([]);
  let user = useSelector((state) => state.login);

  useEffect(()=> {
    getReportData();
  },[duration, isCustomFilter]);

  const getReportData = async() => {
    try {
      const response = await commonRunQuery(254, `${startDate}/${endDate}`);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
        setReportData(reportsArray);
        console.log("ConcentrationReport_getReportData==========",reportsArray);
      } else {
        setReportData([]);
      }
      console.log("getReportData---------------",response);
    } catch (error) {
      console.log("getReportData_error==========",error);
    }
  }

  const columns = [
    {
      label: 'Loan ID',
      getValue: (row) => row.li?.LoanID ?? ''
    },
    {
      label: 'Loan Amount',
      getValue: (row) => row.li?.LoanAmount ?? '',
      align: 'right',
      amount: true
    },
    {
      label: 'Borrower Name',
      getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
    },
    {
      label: 'Country',
      getValue: (row) => row.record?.Country ?? ''
    },
    {
      label: 'State',
      getValue: (row) => row.record?.State?.toString().trim() ? row.record?.State : "-" 
    },
    {
      label: 'City',
      getValue: (row) => row.u?.City?.toString().trim() ? row.u?.City : "-"
    }
  ];

  return (
    <Box>
      <LoanReportsTable 
        data={reportData} 
        columns={columns} 
        title="Concentration Report" 
        formatRow={(row) => [
          row.li?.LoanID,
          row.li?.LoanAmount,
          row.record?.BorrowerName,
          row.record?.Country,
          row.record?.State,
          row.u?.City,
        ]} 
        author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
        />
    </Box>
  )
}

export default ConcentrationReport;
